import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const SponsorDonne = () => {
  return (
    <section data-testid="donnaimpresa-banner" className="bg-brand-red text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 md:py-14 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center gap-5 md:gap-7"
        >
          <div className="shrink-0 bg-white px-4 py-3 flex items-center justify-center">
            <img
              src="/logo-donnaimpresa.png"
              alt="DonnaImpresa — la community delle donne che fanno impresa"
              className="h-9 md:h-11 w-auto"
            />
          </div>
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-white/70 mb-2">
              Impresa al femminile
            </div>
            <p className="font-heading font-bold text-xl md:text-2xl leading-tight max-w-2xl">
              TREFFE è guidata da due donne imprenditrici ed è sponsor ufficiale di{" "}
              <span className="underline underline-offset-4 decoration-white/60">DonnaImpresa</span>,
              la community delle donne che fanno impresa.
            </p>
          </div>
        </motion.div>
        <motion.a
          href="https://donnaimpresa.net/"
          target="_blank"
          rel="noreferrer"
          data-testid="donnaimpresa-link"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="shrink-0 inline-flex items-center gap-2 bg-white text-brand-black font-bold uppercase tracking-widest text-xs md:text-sm px-7 py-4 hover:bg-brand-black hover:text-white transition-colors"
        >
          Visita donnaimpresa.net <ArrowRight size={15} />
        </motion.a>
      </div>
    </section>
  );
};
